import { PermissionFunction, PermissionFunctionKey } from '../permissions/permissions-utils';

export function hasParentId(
  permissionFunctionDef: (typeof PermissionFunction)[keyof typeof PermissionFunction]
): permissionFunctionDef is (typeof PermissionFunction)[keyof typeof PermissionFunction] & {
  parentId: PermissionFunctionKey;
} {
  return 'parentId' in permissionFunctionDef && permissionFunctionDef.parentId !== undefined;
}
